/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 v-if="community" class="ion-text-center">{{ community.name}}</h1>
        <h1 v-if="!community" class="ion-text-center">{{ $t('Community.title')}}</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content class="mc-carpool-community" color="primary" forceOverscroll="false">
      <div
        class="ion-text-center ion-margin-top"
        v-if="this.$store.getters.statusGetCommunity == 'loading' || this.$store.getters.statusJoinCommunity == 'loading'"
      >
        <ion-icon size="large" color="light" class="rotating" name="sync"></ion-icon>
      </div>

      <div
        class="ion-text-center ion-margin-top"
        v-if="!(this.$store.getters.statusGetCommunity == 'loading' || this.$store.getters.statusJoinCommunity == 'loading') && !community"
      >Une erreur est survenue</div>

      <div v-if="community">
        <div class="mc-community-avatar">
          <ion-thumbnail>
            <img style="object-fit: contain" :src="!!community.images[0] ? community.images[0].versions.square_250 : '/assets/communities.png'" alt="" />
          </ion-thumbnail>
          <ion-chip v-if="community.nbMembers" class="custom-chip" color="light" outline="false">
            <ion-label>{{$t('Community.memberNumber', {nb: community.nbMembers})}}</ion-label>
          </ion-chip>
        </div>

        <div class="mc-community-description mc-community-padding">
          <div class="ion-margin-bottom">{{community.description}}</div>

          <MiniMap :LMarker="LMarker" :LPolyline="LPolyline" :communities="[this.community.id]" />

          <ion-button
            v-if="!community.member"
            :disabled="isNotInDomain()"
            class="mc-big-button join-community mb-0"
            color="success"
            expand="block"
            v-on:click="joinCommunity()"
          >
            <ion-icon
              size="large"
              color="light"
              class="rotating"
              name="sync"
              v-if="this.$store.getters.statusJoinCommunity == 'loading'"
            ></ion-icon>
            <div v-if="this.$store.getters.statusJoinCommunity != 'loading'">
              <ion-icon name="add" class="ion-padding-end"></ion-icon>
              {{ $t('Community.joinCommu')}}
            </div>
          </ion-button>
          <div v-if="!community.member && community.domain" class="text-center">{{ $t('Community.domain')}} {{community.domain}}</div>
        </div>
      </div>
      <div class="mc-white-container" v-if="community">
        <div class="mc-community-users" v-if="community.member">
          <p>{{ $t('Community.members')}}</p>
          <ion-row>
            <div>
              <div
                v-for="(user, index) in communityUsers"
                :key="index"
                class="scroll-item pointer"
                @click="goToMessage(user)"
              >
                <ion-thumbnail>
                  <img :src="webURL + user.avatar" alt="" />
                </ion-thumbnail>
                {{user.firstName}} {{user.shortFamilyName}}

                <div>
                  <ion-icon
                    size="large"
                    color="primary"
                    name="star"
                    v-if="idCommunityReferent == user.id"
                  ></ion-icon>
                  <ion-icon
                    size="large"
                    color="primary"
                    name="star-half"
                    v-if="user.status == 2 && !idCommunityReferent == user.id"
                  ></ion-icon>
                  <ion-icon size="large" color="primary" name="chatboxes"></ion-icon>
                </div>


              </div>
            </div>
          </ion-row>
        </div>

        <SearchQuick
          :showPost="community.member"
          :searchWithFilter="true"
          :postWithFilter="true"
          :communities="[this.community.id]"
        />

        <ion-button
          v-if="community.member"
          class="mc-big-button"
          color="danger"
          expand="block"
          :disabled="isOwner()"
          v-on:click="leaveCommunity()"
        >
          <ion-icon
            size="large"
            color="light"
            class="rotating"
            name="sync"
            v-if="this.$store.getters.statusLeaveCommunity == 'loading'"
          ></ion-icon>
          <div v-if="this.$store.getters.statusLeaveCommunity != 'loading'">
            <ion-icon name="close" class="ion-padding-end"></ion-icon>
            {{ $t('Community.leaveCommu')}}
          </div>
        </ion-button>
        <div class="mc-leave-text text-center" v-if="isOwner()"><small>{{ $t('Community.isOwnerLeave')}}</small></div>
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">
.mc-carpool-community {
  .mc-community-avatar {
    display: flex;
    justify-content: center;
    ion-thumbnail {
      --size: 90px;
      --border-radius: 50%;
    }
  }

  .mc-community-padding {
    padding: 20px;
  }

  .mc-community-users {
    background: rgba(var(--ion-color-primary-rgb), 0.1);
    border-radius: 30px;
    color: var(--ion-color-primary);
    font-weight: bold;
    padding: 10px 20px;
    margin-bottom: 40px;

    ion-scroll[scrollX] {
      white-space: nowrap;
      width: 100%;
      overflow: scroll;
      display: flex;

      .scroll-item {
        background: white;
        border-radius: 30px;
        margin: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        width: 120px;
        min-width: 120px;
        height: 160px;
        ion-thumbnail {
          --border-radius: 50%;
        }
      }
    }
  }
}

  .join-community {
    margin-top: 20px;
  }

  .mc-leave-text {
    color: var(--ion-color-danger);
  }

  .ion-color-light.custom-chip {
    --ion-color-base: var(--ion-color-light)!important;
    --ion-color-base-rgb: var(--ion-color-light-rgb, 244, 245, 248)!important;
    --ion-color-contrast: var(--ion-color-light-contrast, #000)!important;
    --ion-color-contrast-rgb: var(--ion-color-light-contrast-rgb, 0, 0, 0)!important;
    --ion-color-shade: var(--ion-color-light)!important;
    --ion-color-tint: var(--ion-color-light-tint, #f5f6f9)!important;
    border: 1px white solid;
  }
</style>

<script>
import { toast } from "../../../Shared/Mixin/toast.mixin";
import SearchQuick from "../../Shared/Components/SearchQuick.component";
import MiniMap from "../../Shared/Components/MiniMap.component";
import store from "../../../Shared/Store/store";
import {alertController} from "@ionic/vue";

export default {
  name: "carpool-community",
  mixins: [toast],
  components: { SearchQuick, MiniMap },
  data() {
    return {
      community: "",
      LPolyline: [],
      LMarker: [],
      communityUsers: [],
      webURL: process.env.VUE_APP_WEB_URL,
      registerCommunity: process.env.VUE_APP_REGISTER_COMMUNITY
    };
  },
  created() {

    // this.getAdsCommunity()
  },
  ionViewWillEnter() {
    this.getSpecificCommunity();
  },
  computed: {
    idCommunityReferent() {
      return this.community.user.id;
    }
  },
  methods: {
    getSpecificCommunity() {
      // On récupére les communities\
      const communityId = this.$route.params.id;
      this.$store
        .dispatch("getSpecificCommunity", communityId)
        .then(resp => {
          this.community = resp.data;

            this.$store
              .dispatch("getSpecificCommunityMembers", communityId)
              .then(respUsers => {
                console.log(respUsers)
                this.communityUsers = respUsers;
              }).catch(err => {
                console.log(err)
              })



              this.$store
                .dispatch("getSpecificCommunityMapsAds", communityId)
                .then(respAds => {
                  this.LMarker.push({
                    latlng: [
                      this.community.address.latitude,
                      this.community.address.longitude
                    ],
                    name: this.community.name
                  });

                  if (!this.community.proposalsHidden) {
                    this.constructDataMap(respAds);
                  }
                });



        })
        .catch(error => {
          console.log(error)
            const securised = this.$route.query.securised;
          if (error.response.status == 400 && securised) {
            this.openJoinSecurity();
            //this.$store.commit('redirectionUrl_change', {name: 'carpool-community', params: {id: communityId}});
            // this.$router.push({ name: "login" });
          } else {
            this.presentToast(this.$t("Commons.error"), "danger");
          }

        });
    },

    /*
    getAdsCommunity() {
      // On récupére les communities\
      const communityId = this.$route.params.id;
      this.$store
        .dispatch("getAdsCommunity", communityId)
        .then(resp => {
          this.constructDataMap(resp.data["hydra:member"]);
        })
        .catch(error => {
          console.log(error);
          this.presentToast(this.$t("Commons.error"), "danger");
        });
    },

     */

    joinCommunity() {
      if (!!!this.$store.state.userStore.user) {
        if (this.registerCommunity) {
          // if there is no user to register yet, initialize the register store userToRegister with the default user to register
          if(!!!this.$store.state.registerStore.userToRegister){
            this.$store.commit("register_reset");
          }
          this.$store.state.registerStore.userToRegister.communityId = this.community.id;
        }
        this.$store.commit('redirectionUrl_change', {name: 'carpool-community', params: {id: this.community.id}});
        this.$router.push({ name: 'login'})
      } else {

          this.$store
            .dispatch("joinCommunity", {communityId: this.community.id})
            .then(resp => {
              if (this.community.validationType == 1) {
                this.presentToast(this.$t("Community.join_manual_success"), "success");
              } else {
                this.presentToast(this.$t("Community.join_success"), "success");
              }

              this.getSpecificCommunity();
            })
            .catch(error => {
              if(error.response.status === 403) {
                this.presentToast(this.$t("Community.join-error"), "danger");
              } else {
                this.presentToast(this.$t("Commons.error"), "danger");
              }
            });
        
      }
    },

    leaveCommunity() {
      return alertController
        .create({
          header: this.$t("Community.leaveCommu"),
          message: this.$t( "Community.leaveHasMember"),
          buttons: [
            {
              text: this.$t("Commons.cancel"),
              role: 'cancel',
              cssClass: 'secondary'
            },
            {
              text: this.$t("Commons.confirm"),
              handler: () => {
                this.$store
                  .dispatch("leaveCommunity", this.community.id)
                  .then(resp => {
                    this.presentToast(this.$t("Community.leave_success"), "success");
                    this.getSpecificCommunity();
                  })
                  .catch(error => {
                    this.presentToast(this.$t("Commons.error"), "danger");
                  });
              },
            },
          ],
        })
        .then(a => a.present());

    },

    openJoinSecurity() {
      if (!!!this.$store.state.userStore.user) {
        const communityId = this.$route.params.id;
        this.$store.commit('redirectionUrl_change', {name: 'carpool-community', params: {id: communityId}, query: {securised: true}});
        this.$router.push({ name: "login" });
      } else {
        return alertController
          .create({
            header: this.$t("Community.security-header"),
            inputs: [
              {
                type: 'text',
                name: 'first',
                placeholder: '1er identifiant',
              },
              {
                type: 'text',
                name: 'second',
                placeholder: '2ème identifiant',
              },
            ],
            buttons: [
              {
                text: this.$t("Commons.cancel"),
                role: 'cancel',
                cssClass: 'secondary'
              },
              {
                text: this.$t("Community.joinCommu"),
                handler: (event) => {

                  const mdp = {
                    login: event.first,
                    password: event.second
                  }

                  const communityId = this.$route.params.id;
                  this.$store
                    .dispatch("joinCommunity", {communityId: communityId, data: mdp})
                    .then(resp => {
                      if (this.community.validationType == 1) {
                        this.presentToast(this.$t("Community.join_manual_success"), "success");
                      } else {
                        this.presentToast(this.$t("Community.join_success"), "success");
                      }

                      this.getSpecificCommunity();
                    })
                    .catch(error => {
                      if (error.response.status === 403) {
                        this.presentToast(this.$t("Community.join-error"), "danger");
                      } else {
                        this.presentToast(this.$t("Commons.error"), "danger");
                      }
                      this.openJoinSecurity()
                    });
                },
              },
            ],
          })
          .then(a => a.present());
      }
    },


    constructDataMap(data) {
      let polylines = [];
      data.forEach(element => {
        let result = [];
        result.push([element.origin.latitude, element.origin.longitude]);
        result.push([element.destination.latitude, element.destination.longitude]);
        /*
        element.outwardWaypoints.forEach(wayPoint => {
          result.push([wayPoint.address.latitude, wayPoint.address.longitude]);
        });
         */
        const polyline = {latlng: result, data: element}

        polylines.push(polyline);
      });

      this.LPolyline = polylines;
    },

    goToMessage(user) {
      user.givenName = user.firstName;
      user.avatars = [this.webUrl + user.avatar];
      this.$store.commit('set_temp_direct_thread', user);
      this.$router.push({ name: "message" , params : {idAsk : -99, idRecipient : user.id}});
    },

    isOwner() {
      return this.$store.getters.userId === this.idCommunityReferent
    },

    isNotInDomain() {
      if (!this.community.domain) {
        return false;
      }
      if (!!!this.$store.state.userStore.user) {
        return false;
      }
      const email = this.$store.state.userStore.user.email;
      const domains = this.community.domain.replaceAll(' ', '').split(';');
      const finded = domains.find(item => email.includes(item))
      return !!finded ? false : true;
    }

  }
};
</script>
